import { Box } from '@mui/material'

import IconExtension from 'src/components/shared/ui/IconExtension'
import ToolTipEllipsis from 'src/components/shared/ui/TooltipEllipsis'
import { adjuntoStyles as styles } from 'src/components/views/Message/components/Adjunto/AdjuntoStyles'

type Props = {
  adjunto: any
}

export default function Adjunto({ adjunto }: Props): JSX.Element {
  // const isPdf = adjunto.nombre.endsWith('.pdf')
  const icon = <IconExtension fileName={adjunto.nombre} />

  return (
    <Box component="div" sx={styles.adjunto}>
      <Box component="div" sx={styles.icon}>
        {icon}
      </Box>
      <ToolTipEllipsis text={adjunto.nombre}>
        <Box component="div" sx={styles.nombre}>
          {adjunto.nombre}
        </Box>
      </ToolTipEllipsis>
    </Box>
  )
}
